/** Non-alcoholic base heuristic (covers sheet typo "Non-alchohol"). */
const NON_ALCOHOL_RE = /non[- ]?alch?ohol/i;

/** Venues with matching Sheets tabs / stock columns. */
export const VENUES = ["Tallinn", "Adelaide"];

/** Multi-select taste leanings shown on the prefs landing / Preferences page. */
export const TASTE_OPTIONS = [
    "bitter",
    "tart",
    "sweet",
    "fruity",
    "citrusy",
    "herbal",
    "floral",
    "creamy",
    "nutty",
    "spicy",
    "refreshing",
    "boozy",
    "light",
    "dry",
    "smoky",
    "tropical",
    "bubbly"
];

export const DEFAULT_GUEST_PREFS = {
    completed: false,
    language: null,
    drinkType: null,
    tastes: [],
    venue: null
};

export const isNonAlcoholicDrink = (drink) => NON_ALCOHOL_RE.test(drink?.baseIngredient || "");

export const drinkMatchesType = (drink, drinkType) => {
    if (drinkType === "nonAlcoholic") return isNonAlcoholicDrink(drink);
    if (drinkType === "alcoholic") return !isNonAlcoholicDrink(drink);
    return true;
};

export const normalizeVenue = (venue) => {
    if (!venue || typeof venue !== "string") return null;
    const match = VENUES.find((v) => v.toLowerCase() === venue.trim().toLowerCase());
    return match || null;
};

export const normalizeGuestPrefs = (prefs) => {
    const tastes = Array.isArray(prefs?.tastes)
        ? prefs.tastes.filter((t) => TASTE_OPTIONS.includes(t))
        : [];
    return {
        ...DEFAULT_GUEST_PREFS,
        ...prefs,
        tastes,
        venue: normalizeVenue(prefs?.venue)
    };
};

export const prefsAreComplete = (prefs) =>
    Boolean(prefs?.completed && prefs?.language && prefs?.drinkType);

/** Compact prefs payload for the AI bartender API. */
export const prefsForChat = (prefs) => {
    const normalized = normalizeGuestPrefs(prefs);
    const payload = {
        language: normalized.language || null,
        drinkType: normalized.drinkType || null,
        tastes: normalized.tastes
    };
    if (normalized.venue) {
        payload.venue = normalized.venue;
    }
    return payload;
};
